import { ConditionState } from '@retail/calculus/types';
import { ToggleGroup, ToggleGroupOption } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { useMemo } from 'react';

interface Props {
  conditionState: ConditionState;
  setConditionState: (newView: ConditionState) => void;
}

export const StateToggleButton = ({ conditionState, setConditionState }: Props) => {
  const t = useMyAssortmentTFunction();

  const options: ToggleGroupOption<ConditionState>[] = useMemo(
    () => [
      { label: t('myAssortment.filter.current'), value: 'ACTIVE' },
      { label: t('myAssortment.filter.future'), value: 'FUTURE' },
      { label: t('myAssortment.filter.all'), value: 'ACTIVE_AND_FUTURE' },
    ],
    [t]
  );

  return (
    <ToggleGroup
      variant="pill"
      label={t('myAssortment.filter.types')}
      labelDirection="vertical"
      options={options}
      fullWidth
      value={conditionState ?? 'ACTIVE'}
      onChange={setConditionState}
      size="small"
    />
  );
};
